// @ts-nocheck
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
// import Page from "@insite/mobius/Page"; // Starter Custom Code
// import * as React from "react"; // Foundation
// import { ReactNode } from "react"; // Foundation
// import styled from "styled-components"; // Starter Custom Code

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Page, { PageProps } from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SiteWrapper, { SiteWrapperPresentationProps } from "@store/Library/Components/Toolkit/SiteWrapper";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import ExperimentsSnippets from "@toolkit/Library/Components/Injectors/ExperimentsSnippets";
import FraudProtectionFingerprint from "@toolkit/Library/Components/Injectors/FraudProtection/FraudProtectionFingerprint";
import GoogleAnalytics from "@toolkit/Library/Components/Injectors/GoogleAnalytics";
import { stretchStyles } from "@toolkit/Themes/common/mixins";

import styled, { css } from "styled-components";

// Foundation --->
import useHandleScroll from "@store/Framework/Common/Hooks/useHandleScroll";
import ScrollContextProvider from "@store/Framework/ContextApi/ScrollContextProvider";
import useHeaderHeight from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useHeaderHeight";
import useIsHeaderFixed from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useIsHeaderFixed";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { AnchorContextProvider } from "@toolkit/Framework/Components/AnchorContext";
import React, { FC, ReactNode } from "react";
// <--- Foundation

/* Store Custom Code - Start */
import KeepMeLoggedInModal from "@store/Library/Components/Starter/KeepMeLoggedInModal";
/* Store Custom Code - End */

export interface PageLayoutStyles {
    siteWrapper?: SiteWrapperPresentationProps;
    content?: InjectableCss;
    // Starter Custom Code
    header?: InjectableCss;
    breadcrumb?: PageProps;
    footer?: InjectableCss;
}

const pageLayoutStyles: PageLayoutStyles = {
    header: {
        css: css`
            position: relative;
            z-index: 4;

            > ${StyledWrapper}:first-child:last-child {
                ${x => breakpointValues(x.theme.design.header.height, "height")}

                svg {
                    display: none; /* Disable DelayedSpinner */
                }
            }
        `,
    },
    breadcrumb: {
        css: css`
            position: relative;
            z-index: 3;

            @media print {
                display: none;
            }
        `,
    },
    content: {
        css: css`
            ${stretchStyles()}
            position: relative;
            z-index: 2;
        `,
    },
    footer: {
        css: css`
            position: relative;
            z-index: 1;
        `,
    },
};

const styles = pageLayoutStyles;
/* Starter Custom Code - End */

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
}: PageLayoutProps) => {
    return (
        <ScrollContextProvider /* Foundation -- ScrollContextProvider */>
            <SiteWrapper {...styles.siteWrapper /* Starter Custom Code */}>
                <PageLayoutWrapper /* Foundation -- PageLayoutWrapper */>
                    {showHeader && <StyledWrapper {...styles.header}>{header}</StyledWrapper>}
                    {/* Starter Custom Code */}
                    {showCompactHeader && compactHeader}
                    {showBreadcrumbs && (
                        <Page as="div" {...styles.breadcrumb /* Starter Custom Code */}>
                            <PageBreadcrumbs />
                        </Page>
                    )}
                    {/* Starter Custom Code - Start */}
                    <KeepMeLoggedInModal />

                    {/* Foundation ---> */}
                    <StyledWrapper {...styles.content}>
                        <AnchorContextProvider>{pageContent}</AnchorContextProvider>
                    </StyledWrapper>
                    {/* <--- Foundation */}
                    {showFooter && <StyledWrapper {...styles.footer}>{footer}</StyledWrapper>}
                    <ExperimentsSnippets />
                    <GoogleAnalytics />
                    <FraudProtectionFingerprint />
                    {/* Starter Custom Code - End */}
                    {showSignInOverlay && signInOverlay}
                    {showStorePickupOverlay && storePickupOverlay}
                    {showAddressBookOverlay && addressBookOverlay}
                </PageLayoutWrapper>
            </SiteWrapper>
        </ScrollContextProvider>
    );
};

// Store Custom Code - >
const PageLayoutWrapper: FC = ({ children }) => {
    const { isStateHeaderFixed } = useIsHeaderFixed();
    useHandleScroll();
    const { headerHeight } = useHeaderHeight();
    const wrapperStyles: InjectableCss = {
        css: css`
            margin-top: 0;

            ${isStateHeaderFixed
                ? css`
                      ${breakpoint("md")} {
                          margin-top: ${pxToRem(
                              headerHeight.mainHeight +
                                  headerHeight.secondaryHeight +
                                  headerHeight.tabbedNavigationHeight,
                          )};
                      }
                  `
                : css`
                      ${breakpoint("md")} {
                          margin-top: 0;
                      }
                  `}
        `,
    };

    return <StyledWrapper {...wrapperStyles}>{children}</StyledWrapper>;
};
// <--- bunzl custom code

export default PageLayout;
